/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsDesignListItem,
    SharedserviceMelcoModelsDesignListItemFromJSON,
    SharedserviceMelcoModelsDesignListItemFromJSONTyped,
    SharedserviceMelcoModelsDesignListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem
 */
export interface SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignListItem>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem
     */
    list: Array<SharedserviceMelcoModelsDesignListItem>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem {
    return SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoModelsDesignListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoModelsDesignListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


